import { render, staticRenderFns } from "./shebao_jiaona.vue?vue&type=template&id=205cdb84&scoped=true"
import script from "./shebao_jiaona.vue?vue&type=script&lang=js"
export * from "./shebao_jiaona.vue?vue&type=script&lang=js"
import style0 from "./shebao_jiaona.vue?vue&type=style&index=0&id=205cdb84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205cdb84",
  null
  
)

export default component.exports